import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { FiscalDeviceRegistryCreateEventCommand, FiscalDeviceRegistryCreateEventCommandHandlerBase, FiscalDeviceRegistryEventResponse, FiscalDeviceRegistryUpdateEventCommand, FiscalDeviceRegistryUpdateEventCommandHandlerBase } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(FiscalDeviceRegistryCreateEventCommand)
@Injectable({ providedIn: 'root'})
export class FiscalDeviceRegistryCreateEventCommandHandler {
    private commandHandler: FiscalDeviceRegistryCreateEventCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new FiscalDeviceRegistryCreateEventCommandHandlerBase(http);
    }

    public async handleAsync(cmd: FiscalDeviceRegistryCreateEventCommand): Promise<FiscalDeviceRegistryEventResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}

@CommandHandlerFor(FiscalDeviceRegistryUpdateEventCommand)
@Injectable({ providedIn: 'root'})
export class FiscalDeviceRegistryUpdateEventCommandHandler {
    private commandHandler: FiscalDeviceRegistryUpdateEventCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new FiscalDeviceRegistryUpdateEventCommandHandlerBase(http);
    }

    public async handleAsync(cmd: FiscalDeviceRegistryUpdateEventCommand): Promise<FiscalDeviceRegistryEventResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
